<section id="dashboard">
  <app-sidebar (isToggled)="toggledState($event)"></app-sidebar>
  <main #main id="main">
    <div class="container">
      <router-outlet></router-outlet>
    </div>
  </main>
</section>